import React from 'react';
import LookupAutocomplete from '../../../../../../Components/Controls/LookupAutocomplete/LookupAutocomplete';
import { TableFilterTypesEnum } from '../../../../../../Enums';
export const offerTrackingHeaderData = (updateFilter) => [
  {
    id: 10,
    label: 'offer_id',
    input: 'vendorOfferId',
  },
  {
    id: 10,
    label: 'vendor-offer',
    input: 'vendorOfferName',
    isHiddenFilter: false,
    isSortable: true,
  },
  {
    id: 8,
    label: 'service-category',
    input: 'vendorServiceCategoryName',
    searchableKey: 'vendorServiceCategoryName',
    isHiddenFilter: false,
    isSortable: true,
  },
  {
    id: 7,
    label: 'vendor-name',
    input: 'vendorName',
    searchableKey: 'VendorName',
    isHiddenFilter: false,
    filterType: TableFilterTypesEnum.textInput.key,
    isSortable: true,
  },
  {
    id: 6,
    label: 'vendor-id',
    input: 'vendorId',
    searchableKey: 'vendorId',
    isHiddenFilter: true,
    fieldType: 'number',
    isSortable: true,
  },
  {
    id: 5,
    label: 'date_of_interest',
    input: 'createdOn',
    isHiddenFilter: false,
    fieldKey: 'createdOn',
    searchableKey: 'createdOn',
    fieldType: 'alt-date',
    filterType: TableFilterTypesEnum.datePicker.key,
    isDefaultFilterColumn: true,
    isDate: true,
    dateFormat: 'DD/MM/YYYY - hh:mm A',
    isSortable: true,
  },
  {
    id: 9,
    label: 'offer_status',
    input: 'offerStatus',
    filterComponent: () => (
      <LookupAutocomplete
        lookupName={'OfferStatus'}
        onChange={(_e, newValue) => {
          updateFilter({ offerStatus: newValue?.lookupItemName });
        }}
      />
    ),
  },
  {
    id: 18,
    label: 'promo-code',
    input: 'promoCode',
    searchableKey: 'promoCode',
    isHiddenFilter: true,
    isSortable: true,
  },
  {
    id: 17,
    label: 'qr-code',
    input: 'qrCode',
    searchableKey: 'qrCode',
    isHiddenFilter: true,
  },
  {
    id: 13,
    label: 'discount-percentage',
    input: 'discountPercentage',
    searchableKey: 'discountPercentage',
    isHiddenFilter: true,
    isSortable: true,
    component: (row) => row.discountPercentage && `${row.discountPercentage}%`,
  },
  {
    id: 9,
    label: 'psi_commission',
    input: 'psiCommissionPercentage',
    searchableKey: 'psiCommissionPercentage',
    isHiddenFilter: true,
    isSortable: true,
    component: (row) =>
      row.psiCommissionPercentage && `${row.psiCommissionPercentage}%`,
  },
];
